
import NavigationBottom from "@/mixins/navigation-bottom";
// components
import Spinner from "@/components/common/spinner.vue";

export default NavigationBottom.extend({
  name: "component-navigation-bottom",
  mixins: [NavigationBottom],
  components: { Spinner },
});
